import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Link, browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import SetQuantity from '../Models/SetQuantity';
import withOnline from '../../common/withOnline';
import withGoBack from '../../common/withGoBack';
import withTableName from '../../common/withTableName';
import withSetsSearch from '../../common/withSetsSearch';
import withSetsFilter from '../../common/withSetsFilter';
import withSetsListStateStorage from '../../common/withSetsListStateStorage';
import withPreferenceOptions from '../../common/withPreferenceOptions';
import withPreference from '../../common/withPreference';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';
import {
  renderAlphabetically, ALPHANUMERIC, countImplantInstrument, updateQuantityValue,
  getUser, getTerritoryData, getTeamData
} from '../../common/globals';
import SetRow from './SetRow';
import { initAPIController, searchSets } from '../../utils/utils';
import { getSetMaster, getTableCaseByCaseId } from '../../utils/db';
import CaseChangesNoLonger from '../Models/CasesChangesNoLonger';
import Bugsnag from '../../helpers/bugsnag';
import BarcodeIcon from '../../assets/images/barcode-scan-custom.png';

class SetsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      masterSetsData: [],
      sets: [],
      masterSetsGroup: [],
      setsGroup: [],
      selectedSet: {},
      instrumentCount: 0,
      implantCount: 0,
      deviceType: '',
      procedureType: '',
      isSearch: false,
      selectedSets: 'selectedSets',
      component: '',
      caseDate: moment().format('YYYY-MM-DD'),
      search: '',
      allSetsQty: {},
      masterSelectedSetsQty: {},
      selectedSetsQty: {},
      selectedSetsQtyPayload: []
    };
    this.onlineAlertModal = null;
    this.caseChangesNoLonger = null;
  }

  componentDidMount() {
    try {
      this.onlineAlertModal = new window.bootstrap.Modal(window.$('#onlineInfoModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  componentWillUnmount() {
    try {
      const {
        selectedSetsQty, selectedSets, deviceType, procedureType
      } = this.state;
      const { setSetsListStateStorage } = this.props;
      setSetsListStateStorage({
        selectedSetsQty,
        selectedSets,
        deviceType,
        procedureType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveSets = async (quantity, quantityPayload) => {
    try {
      const {
        selectedSet
      } = this.state;

      this._onEditSets(quantity, selectedSet, quantityPayload);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditSets = (quantity, selectedSet, quantityPayload = 0) => {
    try {
      const {
        isPastRec, notify, setSetsListStateStorage, setsListStateStorage, selectedSetsPayload
      } = this.props;
      const { selectedSetsQty, masterSelectedSetsQty, selectedSets } = this.state;
      if (isPastRec) {
        if (masterSelectedSetsQty[selectedSet.SetName]
          && masterSelectedSetsQty[selectedSet.SetName] > quantity) {
          notify({
            type: 'warning',
            message: 'Sets cannot be removed on or after the case date. Please contact your office for assistance.',
            time: 10
          });
          return false;
        }
      }

      selectedSetsQty[selectedSet.SetName] = quantity;
      setSetsListStateStorage({ ...setsListStateStorage, selectedSetsQty });
      const payloadSet = { ...selectedSet };
      if (quantityPayload !== 'no') {
        payloadSet.PreferenceName = null;
        const findIndex = _.findIndex(selectedSetsPayload,
          { SetName: payloadSet.SetName, PreferenceName: null });

        if (quantityPayload === 'add' || quantityPayload === 'remove') {
          payloadSet.Quantity = quantity;
        } else if (findIndex === -1) {
          payloadSet.Quantity = quantityPayload;
        }

        this._updateSelectedSetsPayload(payloadSet, quantityPayload);
      }

      const nonZeroCount = Object.values(selectedSetsQty).filter((value) => value !== 0).length;
      if (nonZeroCount === 0) {
        this.setState({
          selectedSets: ''
        }, () => {
          this._onFilter();
          this._updateINSIMP();
        });
      }

      this.setState({
        selectedSetsQty,
        selectedSet
      }, () => {
        if (selectedSets !== '') {
          this._onFilter();
        }
        this._updateINSIMP();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _updateSelectedSetsPayload = (set, newQty = 0) => {
    try {
      const { setSelectedSetsPayload } = this.props;
      let { selectedSetsPayload } = this.props;
      let findIndex = -1;

      if (selectedSetsPayload.length > 0) {
        if (newQty === 'remove' || newQty < 0) {
          findIndex = _.findIndex(selectedSetsPayload,
            { SetName: set.SetName });
        } else {
          findIndex = _.findIndex(selectedSetsPayload,
            {
              SetName: set.SetName,
              PreferenceName: set.PreferenceName,
              CasePlanID: set.CasePlanID
              // Quantity: Number(selectedSetsPayload.Quantity) + Number(newQty)
            });
        }
      }

      if (findIndex > -1) {
        if (newQty === 'remove') {
          selectedSetsPayload.map((setQty, key) => {
            if (setQty.SetName === set.SetName) {
              selectedSetsPayload[key].Quantity = 0;
            }
          });
        } else if (newQty > 0) {
          if (typeof selectedSetsPayload[findIndex].Quantity !== 'undefined') {
            selectedSetsPayload[findIndex].Quantity
              = Number(selectedSetsPayload[findIndex].Quantity) + Number(newQty);
          } else {
            selectedSetsPayload[findIndex].Quantity = Number(newQty);
          }
        } else if (newQty <= 0) {
          const selectedSetsCasePlanId = [];
          const selectedSetsPreference = [];
          const selectedSetsManual = [];

          selectedSetsPayload.map((itemSet) => {
            if (itemSet.CasePlanID !== '') {
              selectedSetsCasePlanId.push(itemSet);
            } else if (itemSet.PreferenceName !== null) {
              selectedSetsPreference.push(itemSet);
            } else {
              selectedSetsManual.push(itemSet);
            }
          });
          selectedSetsPayload = [
            ...selectedSetsManual,
            ...selectedSetsPreference,
            ...selectedSetsCasePlanId
          ];

          try {
            let removeQty = newQty;
            selectedSetsPayload.reverse().map((itemSet, index) => {
              if (
                itemSet.SetName === set.SetName && removeQty < 0
              ) {
                const remainQty = Number(itemSet.Quantity) + Number(removeQty);
                if (remainQty < 0) {
                  removeQty = remainQty;
                  selectedSetsPayload[index].Quantity = 0;
                } else {
                  removeQty = 0;
                  selectedSetsPayload[index].Quantity = remainQty;
                }
                throw new Error('Failed to update set');
              }
            });
          } catch (error) {
          }
        } else {
          selectedSetsPayload[findIndex].Quantity = (
            Number(selectedSetsPayload[findIndex].Quantity) + Number(newQty)
          );
        }
      } else {
        if (typeof set.CasePlanID !== 'undefined') {
          const updatedQuantity = !isNaN(Number(newQty)) ? Number(newQty) : 0;
          const updatedSet = {
            ...set,
            Quantity: (typeof set.Quantity !== 'undefined')
              ? Number(set.Quantity) + updatedQuantity
              : updatedQuantity || set.Quantity
          };

          selectedSetsPayload.push(updatedSet);
        } else {
          const findPayloadIndex = _.findIndex(selectedSetsPayload, { SetName: set.SetName });
          if (findPayloadIndex > -1) {
            const updatedQuantity = !isNaN(Number(newQty)) ? Number(newQty) : 0;
            if (typeof selectedSetsPayload[findPayloadIndex].Quantity !== 'undefined') {
              selectedSetsPayload[findPayloadIndex].Quantity
                = Number(selectedSetsPayload[findPayloadIndex].Quantity) + updatedQuantity;
            } else {
              selectedSetsPayload[findPayloadIndex].Quantity = updatedQuantity;
            }
          } else {
            const updatedQuantity = !isNaN(Number(newQty)) ? Number(newQty) : 0;
            const updatedSet = {
              ...set,
              Quantity: (typeof set.Quantity !== 'undefined')
                ? Number(set.Quantity) + updatedQuantity
                : updatedQuantity || set.Quantity
            };

            selectedSetsPayload.push(updatedSet);

            // selectedSetsPayload.push({
            //   ...set
            // });
          }
        }
      }

      setSelectedSetsPayload([...selectedSetsPayload]);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _updateINSIMP = async () => {
    try {
      const { selectedSetsQty, masterSelectedSetsQty } = this.state;
      const { caseTypePreferenceValue, onGetSetsCount } = this.props;
      // add qty to sets
      let masterSets = await getSetMaster();
      masterSets = masterSets.filter(
        (setsRes) => setsRes.CaseType.includes(caseTypePreferenceValue)
      );

      const updatedSets = updateQuantityValue(masterSets, selectedSetsQty, masterSelectedSetsQty);

      // Count implant/instrument
      const qtyImplantInstrument = countImplantInstrument(updatedSets);
      this.setState({
        instrumentCount: qtyImplantInstrument.instrumentQty,
        implantCount: qtyImplantInstrument.implantQty
      });

      onGetSetsCount((
        Number(qtyImplantInstrument.instrumentQty) + Number(qtyImplantInstrument.implantQty)
      ));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSets = (event) => {
    try {
      let { selectedSets } = this.state;
      const { setSetsListStateStorage, setsListStateStorage } = this.props;
      (selectedSets === event.target.value)
        ? selectedSets = ''
        : selectedSets = event.target.value;
      setSetsListStateStorage({ ...setsListStateStorage, selectedSets });
      this.setState({ selectedSets }, () => this._onFilter());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = () => {
    try {
      const { sets, selectedSetsQty } = this.state;
      const { selectedGroup, selectedComponent } = this.props;
      const {
        selectedSets, deviceType, procedureType
      } = this.state;

      let data = [...sets];

      if (selectedSets !== '') {
        data = data.filter((item) => selectedSetsQty[item.SetName] > 0);
      }

      if (deviceType !== '') {
        // data = (data.filter((item) => item.DeviceType === deviceType));
        data = data.filter(
          (item) => item.DeviceType.includes(deviceType)
        );
      }

      if (procedureType !== '') {
        // data = (data.filter((item) => item.ProcedureType === procedureType));
        data = data.filter(
          (item) => item.ProcedureType.includes(procedureType)
        );
      }

      if (selectedGroup !== '') {
        const setsGroupData = [];
        const groupArr = selectedGroup.SetNames !== null ? selectedGroup.SetNames.split(';') : [];
        data.map((value) => {
          if (groupArr.includes(value.SetName)) {
            setsGroupData.push(value);
          }
        });
        data = setsGroupData;
      }

      if (selectedComponent !== '') {
        /* data = data.filter(
          (item) => item.Component === selectedComponent.Component
        ); */
        data = data.filter(
          (item) => item.Component.includes(selectedComponent.Component)
        );
      }

      const setsGroup = renderAlphabetically(data, 'SetName');
      this.setState({
        setsGroup
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = () => {
    try {
      const { isSearch } = this.state;
      const { online, setsSearch } = this.props;
      if (online) {
        this.setState({ isSearch: !isSearch }, () => this._onSearchFocusAndBlur());
        if (isSearch) {
          if (Object.keys(setsSearch).length > 0) {
            const { setsGroup, searchValue } = setsSearch;
            // setSetsSearch({});
            this.setState({
              searchValue,
              setsGroup
            }, () => {
              this._onFilter();
            });
          }
        }
      } else {
        this.onlineAlertModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProcedureTypeClick = (event) => {
    try {
      let { procedureType } = this.state;
      const { setSetsListStateStorage, setsListStateStorage } = this.props;
      (procedureType === event.target.value)
        ? procedureType = ''
        : procedureType = event.target.value;
      setSetsListStateStorage({ ...setsListStateStorage, procedureType });
      this.setState({ procedureType }, () => { this._onFilter(); });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDeviceTypeClick = (event) => {
    try {
      let { deviceType } = this.state;
      const { setSetsListStateStorage, setsListStateStorage } = this.props;
      (deviceType === event.target.value)
        ? deviceType = ''
        : deviceType = event.target.value;
      setSetsListStateStorage({ ...setsListStateStorage, deviceType });
      this.setState({ deviceType }, () => this._onFilter());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLongPress = (index) => {
    try {
      const { onSetLongPress } = this.props;
      onSetLongPress(index);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetSearch = (search, callback = false) => {
    try {
      const {
        setSetsSearch, online, notify, caseTypePreferenceValue, selectedGroup,
        selectedComponent, caseDetail
      } = this.props;
      const { masterSetsGroup, masterSetsData } = this.state;

      this.setState({ searchValue: search });

      const searchData = {
        search_term: search,
        set_type: 'officeset'
      };

      if (online) {
        if (search.length > 2) {
          if (this.apiController) {
            this.apiController.abort();
          }
          this.apiController = initAPIController();
          searchSets(searchData).then((response) => {
            const { status, data } = response;
            if (status) {
              let sets = data.filter(
                (setsRes) => setsRes.CaseType.includes(caseTypePreferenceValue)
              );
              const setsValue = caseDetail.case_sets;
              const masterSelectedSetsQty = {};
              setsValue.map((set) => {
                const { SetName, Quantity } = set;
                masterSelectedSetsQty[SetName] = Number(Quantity);
              });
              if (selectedGroup !== '') {
                const groupArr = selectedGroup.SetNames !== null ? selectedGroup.SetNames.split(';') : [];
                sets = sets.filter((value) => (groupArr.includes(value.SetName)));
              }

              if (selectedComponent !== '') {
                sets = sets.filter(
                  (item) => item.Component.includes(selectedComponent.Component)
                );
              }
              sets.forEach((object) => {
                object.Quantity = 0;
                object.CasePlanID = '';
                object.PreferenceName = null;
              });
              const setsGroup = renderAlphabetically(sets, 'SetName');
              this.setState({
                sets,
                setsGroup
              }, () => {
                callback && callback();
              });
              setSetsSearch({
                isSearch: true,
                setsGroup,
                searchValue: search,
                sets
              });
            }
            if (search.length < 2) {
              setTimeout(() => {
                setSetsSearch({
                  isSearch: true,
                  setsGroup: masterSetsGroup,
                  searchValue: search
                });
                this.setState({
                  sets: masterSetsData,
                  setsGroup: masterSetsGroup,
                }, () => {
                  callback && callback();
                });
              }, 500);
            }
          }).catch(() => {
            if (search.length < 2) {
              setSetsSearch({
                isSearch: true,
                setsGroup: masterSetsGroup,
                searchValue: search
              });
              this.setState({
                sets: masterSetsData,
                setsGroup: masterSetsGroup
              }, () => {
                callback && callback();
              });
            }
          });
        } else {
          if (this.apiController) {
            this.apiController.abort();
          }
          setTimeout(() => {
            setSetsSearch({
              isSearch: true,
              setsGroup: masterSetsGroup,
              searchValue: search
            });
            this.setState({
              setsGroup: masterSetsGroup,
              sets: masterSetsData
            }, () => {
              callback && callback();
            });
          }, 1000);
        }
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.'
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSets = async (props) => {
    try {
      const {
        caseDetail = null,
        caseTypePreferenceValue, setsSearch, setsListStateStorage,
        selectedGroup, selectedComponent, preferenceOptions, setPreferenceOptions,
        setSetsListStateStorage
      } = props;

      const { selectedSetsQty } = this.state;
      let masterSets = await getSetMaster();
      masterSets = masterSets.filter(
        (setsRes) => setsRes.CaseType.includes(caseTypePreferenceValue)
      );

      let selectedSetsQtyNew = setsListStateStorage.selectedSetsQty
        ? setsListStateStorage.selectedSetsQty : selectedSetsQty;

      caseDetail.case_sets = caseDetail.case_sets
        .map(({ CasePlanId, ...rest }) => ({ ...rest, CasePlanID: CasePlanId }));

      const setsValue = (caseDetail && _.isEmpty(selectedSetsQtyNew)) ? caseDetail.case_sets : [];

      // Master Sets Qty
      // const masterSelectedSetsQty = {};
      // setsValue.map((set) => {
      //   const { SetName, Quantity } = set;
      //   masterSelectedSetsQty[SetName] = Number(Quantity);
      // });

      const masterSelectedSetsQty = {};
      setsValue.forEach((set) => {
        const { SetName, Quantity } = set;
        if (masterSelectedSetsQty.hasOwnProperty(SetName)) {
          masterSelectedSetsQty[SetName] = (
            Number(masterSelectedSetsQty[SetName]) + Number(Quantity)
          );
        } else {
          masterSelectedSetsQty[SetName] = Number(Quantity);
        }
      });

      // Current Updated Sets Qty
      if (_.isEmpty(selectedSetsQty)) {
        // setsValue.map(({ SetName, Quantity }) => {
        //   if (!selectedSetsQtyNew[SetName]) {
        //     selectedSetsQtyNew[SetName] = Number(Quantity);
        //   }
        // });

        setsValue.forEach((set) => {
          const { SetName, Quantity } = set;
          if (selectedSetsQtyNew.hasOwnProperty(SetName)) {
            selectedSetsQtyNew[SetName] = (
              Number(selectedSetsQtyNew[SetName]) + Number(Quantity)
            );
          } else {
            selectedSetsQtyNew[SetName] = Number(Quantity);
          }
        });
      } else {
        selectedSetsQtyNew = selectedSetsQty;
      }

      if (_.isEmpty(preferenceOptions)) {
        const setsValueRes = caseDetail.case_sets;
        // Master Sets Qty
        setsValueRes.map((set) => {
          const { SetName, Quantity } = set;
          masterSelectedSetsQty[SetName] = Number(Quantity);
        });

        // setsValueRes.forEach((set) => {
        //   const { SetName, Quantity } = set;
        //   if (masterSelectedSetsQty.hasOwnProperty(SetName)) {
        //     masterSelectedSetsQty[SetName] = (
        //       Number(masterSelectedSetsQty[SetName]) + Number(Quantity)
        //     );
        //   } else {
        //     masterSelectedSetsQty[SetName] = Number(Quantity);
        //   }
        // });
      }

      // Handle preference options
      if (!_.isEmpty(preferenceOptions)) {
        setPreferenceOptions({});
        if (preferenceOptions.type === 'replace') {
          selectedSetsQtyNew = preferenceOptions.data;
        } else {
          Object.keys(preferenceOptions.data).map((key) => {
            selectedSetsQtyNew[key] = selectedSetsQtyNew.hasOwnProperty(key)
              ? Number(selectedSetsQtyNew[key] + preferenceOptions.data[key])
              : Number(preferenceOptions.data[key]);
          });
        }
      } else {
        setsValue.map((set) => {
          this._updateSelectedSetsPayload(set);
        });
      }
      setSetsListStateStorage({ ...setsListStateStorage, selectedSetsQty: selectedSetsQtyNew });
      if (selectedGroup !== '') {
        const setsGroupData = [];
        const groupArr = selectedGroup.SetNames !== null ? selectedGroup.SetNames.split(';') : [];
        masterSets.map((value) => {
          if (groupArr.includes(value.SetName)) {
            setsGroupData.push(value);
          }
        });
        masterSets = setsGroupData;
      }

      if (selectedComponent !== '') {
        masterSets = masterSets.filter(
          (item) => item.Component.includes(selectedComponent.Component)
        );
      }
      const setsGroup = renderAlphabetically(masterSets, 'SetName');
      this.setState({
        masterSetsData: masterSets,
        sets: masterSets,
        allSetsQty: _.chain(masterSets)
          .keyBy('SetName')
          .mapValues('Quantity')
          .value(),
        ...setsListStateStorage,
        selectedSetsQty: selectedSetsQtyNew,
        masterSelectedSetsQty,
        setsGroup,
        masterSetsGroup: setsGroup,
        ...setsSearch,
      }, () => {
        this._onFilter();
        this._updateINSIMP();
        this._onClickSelected();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetsSave = async (cb = () => { }) => {
    try {
      // This will trigger from parent component when save click from Header
      // const { selectedSetsQty, masterSelectedSetsQty } = this.state;
      const { selectedSetsPayload } = this.props;

      /* const { caseTypePreferenceValue } = this.props;
      let masterSets = await getSetMaster();
      masterSets = masterSets.filter(
        (setsRes) => setsRes.CaseType.includes(caseTypePreferenceValue)
      ); */
      // add qty to sets
      // const updatedSets = updateQuantityValue(
      // masterSets, selectedSetsQty, masterSelectedSetsQty);
      cb(selectedSetsPayload);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickExpressCaseBtn = async () => {
    try {
      const { setSetsFilter, selectedComponent, selectedGroup } = this.props;
      const { deviceType, procedureType, selectedSets } = this.state;
      const { id, tableName } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (Object.keys(caseRes).length > 0 && caseRes.DGR === '1') {
        this.caseChangesNoLonger.show();
      } else {
        this._onGoBack();
        setSetsFilter({
          procedureType,
          deviceType,
          selectedSets,
          selectedComponent,
          selectedGroup,
        });
        browserHistory.push(`/manage-case/${id}/sets/express-care-sets`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickPreferenceBtn = async () => {
    try {
      const {
        id, tableName, setSetsFilter, selectedComponent, selectedGroup
      } = this.props;
      const { deviceType, procedureType, selectedSets } = this.state;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (Object.keys(caseRes).length > 0 && caseRes.DGR === '1') {
        this.caseChangesNoLonger.show();
      } else {
        setSetsFilter({
          procedureType,
          deviceType,
          selectedSets,
          selectedComponent,
          selectedGroup,
        });
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/sets/preferences`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchFocusAndBlur = () => {
    try {
      const { isSearch } = this.state;
      (!isSearch) ? window.$('#search').blur() : window.$('#search').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickSelected = () => {
    const { setSetsListStateStorage, setsListStateStorage } = this.props;
    if (Object.keys(setsListStateStorage.selectedSetsQty).length > 0) {
      // this.setState({ selectedSets: 'selectedSets' });
    } else {
      setSetsListStateStorage({ ...setsListStateStorage });
      this.setState({ selectedSets: '' }, () => this._onFilter());
    }
  }

  _onRemoveSearchValue = () => {
    try {
      this.setState({ searchValue: '' });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScanToMove = () => {
    const {
      online, setGoBack, goBack, notify
    } = this.props;
    if (!online) {
      notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
      return;
    }
    setGoBack([...goBack, window.location.pathname]);
    browserHistory.push('/move-sets');
  }

  async UNSAFE_componentWillMount() {
    try {
      const { setChildSetsSave, setsSearch } = this.props;
      if (Object.keys(setsSearch).length) {
        const { searchValue, isSearch } = setsSearch;
        this.setState({ isSearch, searchValue }, () => this._onSearchFocusAndBlur());
      }
      this._getSets(this.props);
      if (setChildSetsSave) {
        setChildSetsSave(this._onSetsSave);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      if (
        JSON.stringify(nextProps.selectedGroup) !== JSON.stringify(this.props.selectedGroup)
        || JSON.stringify(nextProps.selectedComponent)
        !== JSON.stringify(this.props.selectedComponent)) {
        this._getSets(nextProps);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      id, showHeaderButton, onClickComponent, selectedComponent,
      onClickGroup, selectedGroup, caseDetail = null, isPastRec
    } = this.props;
    const {
      isSearch, searchValue, setsGroup, selectedSetsQty, implantCount,
      instrumentCount, selectedSet, caseDate, masterSelectedSetsQty, allSetsQty, selectedSets
    } = this.state;
    const user = getUser();

    return (
      <section className="list-section">
        <section className="sets-section">
          <div className="container">
            <div className="top-block sticky-sets">
              <div className="row gx-2">
                {showHeaderButton
                  ? (
                    <>
                      <div className="col-4">
                        <Link className="btn btn-theme-alt btn-theme-outline-alt d-block" onClick={this._onClickExpressCaseBtn}>ExpressCare</Link>
                      </div>
                      <div className="col-4">
                        <Link className="btn btn-theme-alt btn-theme-outline-alt d-block" onClick={this._onClickPreferenceBtn}>Preferences</Link>
                      </div>
                    </>
                  ) : <div className="col-8" />}

                <div className="col-4">
                  <div className="right-block">
                    <div className="row gx-2">
                      <div className="col-auto">
                        <div className="d-flex justify-content-between ins-data">
                          <span>INS: </span><span>{instrumentCount}</span>
                        </div>
                        <div className="d-flex justify-content-between ins-data">
                          <span>IMP:</span><span>{implantCount}</span>
                        </div>
                      </div>
                      <div className="col align-self-center text-end">
                        <Link className="me-3">
                          <i className="fas fa-search theme-color-yellow cursor-pointer" onClick={this._onSearch} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                {
                  isSearch === true
                    ? (
                      <div className="row gx-2">
                        <div className="col-12">
                          <div className="search-box show mt-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                              value={searchValue}
                              id="search"
                              name="search"
                              onChange={({ target: { value } }) => {
                                this._onSetSearch(value, () => {
                                  this._onFilter();
                                });
                              }}
                            />
                            <span className="icon"><i className="fas fa-search" /></span>
                            {/* { */}
                            {/*  searchValue !== undefined && searchValue.length > 0 */}
                            {/*    ? ( */}
                            {/*      <span className="search-times-icon"> */}
                            {/*        <i */}
                            {/*          className="fas fa-times cursor-pointer" */}
                            {/*          onClick={this._onRemoveSearchValue} */}
                            {/*        /> */}
                            {/*      </span> */}
                            {/*    ) : '' */}
                            {/* } */}
                          </div>
                        </div>
                      </div>
                    )
                    : ''
                }
              </div>
            </div>

            <div className="sets-list-blocks t-b-border-0" style={{ marginBottom: 52 }}>
              {setsGroup.length > 0
                ? setsGroup.map((item, index) => (
                  <SetRow
                    temp={Math.random()}
                    setsQty={Object.assign(allSetsQty, selectedSetsQty)}
                    key={index}
                    onEditSets={this._onEditSets}
                    item={item}
                    index={index}
                    onLongPress={this._onLongPress}
                  />
                )) : <p className="text-center mt-5">No sets match your filters</p>}
            </div>
          </div>
          <ul className="list-unstyled right-filter mt-3">
            {ALPHANUMERIC.map((name, index) => (
              <li key={index}>
                {caseDetail ? (
                  <a href={`/manage-case/${id}/sets#${name.toLowerCase()}`} key={index}>{name}</a>
                ) : (<a href={`/preferences/new/sets#${name.toLowerCase()}`} key={index}>{name}</a>)}
              </li>
            ))}
          </ul>
        </section>

        <section className="sets-footer-section fixed-bottom">
          <div className="sets-footer-inner">
            <div className="container">
              <div className="button-block" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <div className="button-scrollarea">
                  {
                    getTerritoryData(user).isSetMove && getTeamData(user).isSetMove ? (
                      <div>
                        <a
                          role="button"
                          tabIndex={0}
                          style={{ display: 'inline-block', width: 29 }}
                          onClick={this._onScanToMove}
                        >
                          <img style={{ width: 29 }} src={BarcodeIcon} alt="barcode-icon" />
                        </a>
                      </div>
                    ) : null
                  }
                  <div>
                    <button
                      type="button"
                      className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${selectedSets !== '' ? 'active' : ''}`}
                      style={{ width: 100 }}
                      value="selectedSets"
                      onClick={(e) => {
                        this._onSelectedSets(e);
                      }}
                    >Selected
                    </button>
                  </div>
                  <div>
                    <div className="btn-group w-100" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${this.state.deviceType === 'IMPLANT' ? 'active' : ''}`}
                        style={{ width: 90 }}
                        value="IMPLANT"
                        onClick={(e) => this._onDeviceTypeClick(e)}
                      >Implant
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${this.state.deviceType === 'INSTRUMENT' ? 'active' : ''}`}
                        style={{ width: 90 }}
                        value="INSTRUMENT"
                        onClick={(e) => this._onDeviceTypeClick(e)}
                      >Instrument
                      </button>
                    </div>
                  </div>
                  <div>
                    <div className="btn-group w-100" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${this.state.procedureType === 'PRIMARY' ? 'active' : ''}`}
                        style={{ width: 90 }}
                        value="PRIMARY"
                        onClick={(e) => this._onProcedureTypeClick(e)}
                      >Primary
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${this.state.procedureType === 'REVISION' ? 'active' : ''}`}
                        style={{ width: 90 }}
                        value="REVISION"
                        onClick={(e) => this._onProcedureTypeClick(e)}
                      >Revision
                      </button>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${selectedGroup ? 'active' : ''}`}
                      style={{ width: 100 }}
                      onClick={() => onClickGroup()}
                    >Group
                      {/* {selectedGroup ? selectedGroup.SetGroup : 'Group'} */}
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      className={`btn btn-sm btn-theme-alt btn-theme-outline-alt  ${selectedComponent ? 'active' : ''}`}
                      style={{ width: 100 }}
                      onClick={() => onClickComponent()}
                    >{selectedComponent ? selectedComponent.Component : 'Component'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SetQuantity
          qty={selectedSetsQty[selectedSet.SetName]}
          selectedSetName={selectedSet.SetName}
          onSaveSets={this._onSaveSets}
          caseDate={caseDate}
          isPastRec={isPastRec}
          masterSelectedSetsQty={masterSelectedSetsQty}
        />
        <CaseChangesNoLonger
          id={id}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'SetsListForm',
});

export default withTableName(
  withSetsListStateStorage(
    withSetsSearch(
      withPreference(
        withSetsFilter(
          withGoBack(
            withForm(
              withOnline(
                withNotify(
                  withLoader(
                    withPreferenceOptions(
                      withSelectedSetsPayload(
                        SetsList
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
